<template>
  <div :class="classes()">
    <div
      v-if="password === ''"
      :class="`${el}__text`"
      v-html="$t('auth.password.strength.default')"
    />
    <div v-else>
      <UnorderedList
        :class="`${el}__text ${el}__list`"
        :listItems="listItems"
        :iconArray="iconArray"
        :colorArray="iconColorArray"
        noMarginListItems
      />
    </div>
  </div>
</template>

<script>
import UnorderedList from '@/objects/UnorderedList';

export default {
  name: 'PasswordStrength',
  components: {
    UnorderedList,
  },
  props: {
    password: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      iconArray: ['close-line', 'close-line', 'close-line', 'close-line'],
      iconColorArray: ['supportDanger', 'supportDanger', 'supportDanger', 'supportDanger'],
      val: {
        has8Signs: false,
        hasBigSmallLetters: false,
        hasNumbers: false,
        hasSpecialChars: false,
      },
      listItems: [
        this.$t(`auth.password.strength.signs.8chars`),
        this.$t(`auth.password.strength.signs.bigSmallLetters`),
        this.$t(`auth.password.strength.signs.numbers`),
        this.$t(`auth.password.strength.signs.specialCharacters`),
      ],
      el: 'c-passwordStrength',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.strength}`]: this.strength,
        };
      },
    };
  },
  created() {
    this.validatePassword();
  },
  watch: {
    password: function () {
      this.validatePassword();
    },
  },
  methods: {
    validatePassword() {
      this.val.has8Signs = this.password.length >= 8;
      this.val.hasBigSmallLetters =
        this.password !== this.password.toLowerCase() &&
        this.password !== this.password.toUpperCase();
      this.val.hasNumbers = /\d/.test(this.password);
      this.val.hasSpecialChars = /[\W|_/]/.test(this.password);
      Object.values(this.val).forEach((value, index) => {
        if (value) {
          this.$set(this.iconArray, index, 'check-line');
          this.$set(this.iconColorArray, index, 'supportSuccess');
        } else {
          this.$set(this.iconArray, index, 'close-line');
          this.$set(this.iconColorArray, index, 'supportDanger');
        }
      });
      if (!this.val.hasSpecialChars && this.password.length >= 14) {
        this.$set(this.iconArray, 3, 'check-line');
        this.$set(this.iconColorArray, 3, 'supportSuccess');
      }
    },
  },
};
</script>
